// extracted by mini-css-extract-plugin
export default {"textRow":"information-link-option-module__textRow--xNCOB"};